import { render, staticRenderFns } from "./AllIssues.vue?vue&type=template&id=5e9c8f1c&scoped=true"
import script from "./AllIssues.vue?vue&type=script&lang=js"
export * from "./AllIssues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9c8f1c",
  null
  
)

export default component.exports